import parsePhoneNumber from 'libphonenumber-js';

// Mensajes hardcodeados
const messages = {
    mandatory: 'Este campo es obligatorio',
    email: 'Introduce una dirección de correo electrónico válida',
    password: 'La contraseña debe incluir al menos 8 caracteres, un número, una mayúscula y un símbolo especial',
    ccc: 'Introduce un CCC válido',
    nif: 'Introduce un NIF válido',
    nie: 'Introduce un NIE válido',
    dninie: 'Introduce un DNI o NIE válido',
    dninifpassport: 'Introduce un DNI, NIE o pasaporte válido',
    passport: 'Introduce un pasaporte válido',
    naf: 'El NAF debe tener 12 dígitos numéricos',
    iban: 'Introduce un IBAN válido',
    number: 'El valor introducido no es un número',
    tel: 'Introduce un número de teléfono válido',
    date: 'Introduce una fecha válida',
    url: 'Introduce una URL con el formato correcto',
    default: 'El formato introducido no es válido'
};

// Funciones de validación que devuelven true/false
const validators = {

    email: value => {

        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(value).toLowerCase());
    },

    password: value => {

        const strong = /^(?=.*[\W_])(?=.*\d)(?=.*[A-Z]).*$/;
        return value.length >= 8 && strong.test(value);
    },

    ccc: value => {

        if (!value) return false
    
        const cleaned = String(value).replace(/[\s-]/g, '')
    
        const re = /^(\d{11}|\d{15})$/
    
        return re.test(cleaned)
    },

    cif: value => {

        if (!value) return false;
        const v = value.toUpperCase().trim();
        if (!/^[ABCDEFGHJNPQRSUVW]\d{7}[0-9A-J]$/.test(v)) return false;

        const letters = "JABCDEFGHI";
        const type = v[0];
        const digits = v.slice(1, -1);
        const control = v.slice(-1);

        let sum = 0;
        for (let i = 0; i < 7; i++) {
            const n = parseInt(digits[i], 10);
            sum += (i % 2 === 0)
                ? [...String(n * 2)].reduce((a, b) => a + +b, 0)
                : n;
        }

        const digit = (10 - (sum % 10)) % 10;
        const letter = letters[digit];

        return (
            ("ABEH".includes(type) && control == digit) ||
            ("KPQS".includes(type) && control === letter) ||
            (control == digit || control === letter)
        );
    },

    nif: value => {

        if (/^[0-9]{8}[A-Z]$/i.test(value)) return validators.dni(value)
        else if (/^[XYZ][0-9]{7}[A-Z]$/i.test(value)) return validators.nie(value)
        else if (/^[ABCDEFGHJNPQRSUVW][0-9]{7}[0-9A-J]$/i.test(value)) return validators.cif(value)
        else return validators.passport(value)

        // return validators.dni(value) || validators.cif(value) || validators.nie(value) || validators.passport(value)
    },

    dni: value => {

        const nifRegex = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]$/i;
        const number = value.slice(0, -1);
        const letter = value.slice(-1).toUpperCase();
        const validLetter = 'TRWAGMYFPDXBNJZSQVHLCKET'[parseInt(number, 10) % 23];
        return nifRegex.test(value) && letter === validLetter;
    },

    nie: value => {

        const nieRegex = /^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]$/i;
        const prefixMap = { X: '0', Y: '1', Z: '2' };
        const prefix = value.charAt(0).toUpperCase();
        const number = prefixMap[prefix] + value.slice(1, -1);
        const letter = value.slice(-1).toUpperCase();
        const validLetter = 'TRWAGMYFPDXBNJZSQVHLCKET'[parseInt(number, 10) % 23];
        return nieRegex.test(value) && letter === validLetter;
    },

    passport: value => /^(?!^0+$)[a-zA-Z0-9]{5,15}$/i.test(value),
    naf: value => /^[0-9]{12}$/.test(value),
    iban: value => /^[A-Z]{2}\d{22}$/i.test(value),
    number: value => !isNaN(value),
    name: value => /^[\p{L} -]+$/u.test(value),

    tel: value => {

        try { return parsePhoneNumber(value, 'ES')?.isValid(); }
        catch { return false; }
    },

    date: value => {

        if (!value) return false

        if (value instanceof Date) return !isNaN(value.getTime())

        if (typeof value === 'string') {
            
            const s = value.trim()
            if (!s) return false

            // Formato dd/mm/yyyy
            const m = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)

            if (m) {

                const day = +m[1]
                const month = +m[2]
                const year = +m[3]

                const date = new Date(year, month - 1, day)

                return (date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day)
            }

            const t = Date.parse(s)
            return !isNaN(t)
        }

        return false
    },

    url: value => {

        try {

            const url = new URL(value);
            return url.href.includes('//');

        } catch { return false; }
    }
};

export const validation = {

    empty: value => {

        if (value === null || value === undefined) return true
        if (typeof value === 'string') return !(value && value.trim())
        if (typeof value === 'number') return false
        if (Array.isArray(value)) return !value.length
        if (value instanceof Date) return false
        if (typeof value === 'object') return !Object.keys(value).length
        return !value;
    },

    check: (value, type) => {

        // Campo obligatorio
        if (validation.empty(value)) return { empty: true, msg: messages.mandatory };

        // Lista de valores
        if (Array.isArray(type)) {

            return type.includes(value) ? { valid: true } : { valid: false, msg: 'El valor debe ser uno de los esperados' }
        }

        // Regex personalizado
        if (typeof type === 'object') {

            const regex = new RegExp(type.pattern || type.regex, type.flags);
            const valid = regex.test(value);

            return valid
                ? { valid: true }
                : { valid: false, msg: messages.default };
        }

        // Soporte para múltiples tipos (nif-nie, nif,nie, nif;nie)
        const types = String(type).split('|').map(t => t.trim());
        let isValid = false;

        for (const key of types) {

            if (key in validators) {

                if (validators[key](value)) {
                    isValid = true;
                    break;
                }

            } else isValid = true;
        }

        if (!isValid) {

            const compositeKey = types.length > 1 ? types.sort().join('') : type;
            return { valid: false, msg: (messages[compositeKey] || messages.default) };
        }

        return { valid: true, type };
    }
};

export default validation;